import { useCallback } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { fichaDeParams, paramsConFicha } from './comercialLogica'

// A form with unsaved changes in the panel guards it: () => may the card be
// left? (it asks the user). One at a time; fijarGuardia returns its release.
let guardia = null
export function fijarGuardia(fn) {
  guardia = fn
  return () => { if (guardia === fn) guardia = null }
}
const puedeSalir = () => !guardia || guardia()

// The open record card lives in the address (?org=<id> or ?contacto=<id>), so
// an organization and a contact link to each other from any Comercial page
// without leaving it. Each card opened is a browser history entry: "‹" (and the
// browser's back) returns to the previous card, and closing goes back to the
// list as it was before the first one. Opening, going back and closing first
// ask the form being edited, if any (fijarGuardia).
export default function useFichaComercial() {
  const [params] = useSearchParams()
  const location = useLocation()
  const navigate = useNavigate()
  const ficha = fichaDeParams(params)
  const profundidad = location.state?.fichasComercial || 0      // cards opened from this list

  //   extra: more of the card in the address, e.g. { superior } for a new organization
  const abrir = useCallback((tipo, id, extra) => {
    if (!puedeSalir()) return
    navigate({ search: paramsConFicha(params, { tipo, id, ...extra }).toString() },
      { state: { fichasComercial: (ficha ? profundidad : 0) + 1 } })
  }, [navigate, params, ficha, profundidad])
  // This card becomes another in the same history entry (a new organization, once created).
  const reemplazar = useCallback((tipo, id) => {
    navigate({ search: paramsConFicha(params, { tipo, id }).toString() },
      { replace: true, state: location.state })
  }, [navigate, params, location.state])
  const atras = useCallback(() => { if (puedeSalir()) navigate(-1) }, [navigate])
  const cerrar = useCallback(() => {
    if (!puedeSalir()) return
    if (profundidad > 0) navigate(-profundidad)
    else navigate({ search: paramsConFicha(params, null).toString() }, { replace: true })   // opened from a link
  }, [navigate, params, profundidad])

  return { ficha, abrir, reemplazar, atras: profundidad > 1 ? atras : null, cerrar }
}
